import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { MapSet, mapSetSchema } from './schemas/map-set.schema';
import { messageSchema } from './schemas/message-schema';

export function postMapSets(mapSet: Partial<MapSet>) {
  return fromFetch(
    new Request(fleetEnvironment.mapSetsUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
      body: JSON.stringify(mapSet),
    })
  ).pipe(
    selectData(
      messageSchema.extend({
        data: mapSetSchema,
      })
    )
  );
}
